import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { ReviewConfigForm } from './ReviewConfigForm';

import type { ReviewConfigModalProps } from './types';
import type { CreateReviewConfigDto } from '@repo/shared-types';

export const ReviewConfigModal = ({
  open,
  onOpenChange,
  config,
  onSubmit,
  errors = [],
  isLoading = false,
}: ReviewConfigModalProps) => {
  const isEditing = config !== null;

  const handleFormSubmit = (formData: CreateReviewConfigDto) => {
    onSubmit(formData);
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60" />
        <Dialog.Content className="bg-background fixed inset-0 z-50 flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between border-b px-6 py-4">
            <Dialog.Title className="text-lg font-semibold">
              {isEditing ? 'Edit review configuration' : 'New review configuration'}
            </Dialog.Title>

            <Dialog.Close asChild>
              <Button variant="ghost" size="icon">
                <X className="h-4 w-4" />
              </Button>
            </Dialog.Close>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto scroll-smooth p-6">
            <ReviewConfigForm
              initialValues={config ?? undefined}
              onSubmit={handleFormSubmit}
              errors={errors}
              isLoading={isLoading}
              submitLabel={isEditing ? 'Save changes' : 'Create configuration'}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
